import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, FullHeight, Loader } from '@marvelapp/ui';
/** @param {any} */
export default function FullScreenLoader({ bg }) {
    return (_jsx(FullHeight, { children: _jsx(Flex, { alignItems: "center", bg: bg, justifyContent: "center", minHeight: "100%", width: "100%", children: _jsx(Loader, { size: 24, testId: "full-screen-loader" }) }) }));
}
